import { openDB, type IDBPDatabase } from 'idb';

const DB_NAME = 'indexeddbGDVS';
const DB_VERSION = 1;
const CHAPTERS_STORE = 'chaptersGDVS';
const VERSES_STORE = 'versesGDVS';

let dbPromise: Promise<IDBPDatabase> | null = null;

function getDb(): Promise<IDBPDatabase> {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(CHAPTERS_STORE)) {
          db.createObjectStore(CHAPTERS_STORE);
        }
        if (!db.objectStoreNames.contains(VERSES_STORE)) {
          db.createObjectStore(VERSES_STORE);
        }
      },
    });
  }
  return dbPromise;
}

export async function saveChapters(chapters: unknown[]) {
  const db = await getDb();
  const tx = db.transaction(CHAPTERS_STORE, 'readwrite');
  for (let i = 0; i < chapters.length; i++) {
    tx.store.add(chapters[i], i + 1);
  }
  await tx.done;
}

export async function getChapters(lower: number, upper: number) {
  const db = await getDb();
  const tx = db.transaction(CHAPTERS_STORE, 'readonly');
  const results: unknown[] = [];
  let cursor = await tx.store.openCursor(IDBKeyRange.bound(lower, upper));
  while (cursor) {
    results.push(cursor.value);
    cursor = await cursor.continue();
  }
  return results;
}

export async function saveVerses(verses: Record<string, Record<string, unknown>>) {
  const db = await getDb();
  const tx = db.transaction(VERSES_STORE, 'readwrite');
  const keys = Object.keys(verses);
  for (const key of keys) {
    verses[key]['updated'] = Date.now();
    tx.store.put(verses[key], key);
  }
  await tx.done;
}

export async function getVerses(chapterNo: string, verseFrom: string, verseTo: string) {
  const db = await getDb();
  const tx = db.transaction(VERSES_STORE, 'readonly');
  const results: Record<string, unknown> = {};
  const lower = `${chapterNo}-${verseFrom}`;
  const upper = `${chapterNo}-${verseTo}`;
  let cursor = await tx.store.openCursor(IDBKeyRange.bound(lower, upper));
  while (cursor) {
    results[cursor.key as string] = cursor.value;
    cursor = await cursor.continue();
  }
  return results;
}

export function supportsIDB(): boolean {
  return 'indexedDB' in window;
}
